import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import "react-circular-progressbar/dist/styles.css";
import { useParams } from "react-router-dom";
import {
  getSurveyAssignmentReportBytes,
  getSurveyAssignmentReportHtml,
  getSurveyAssignmentReportWordBytes
} from "../../utils/ApiUrl";
import { axiosPost } from "../../utils/AxiosHelper";
import {
  decrypt,
  downloadDocFromBytes,
  downloadPdfFromBytes
} from "../../utils/common";
import OrganizationLogo from "../header/OrganizationLogo";
import Loader from "../loader/Loader";

const SurveySummaryReport: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [surveyAssignmentId, setSurveyAssignmentId] = useState<number>();
  const [reportHtml, setReportHtml] = useState<string>();

  let { id } = useParams();
  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        const surveyId = await decrypt(id);
        setSurveyAssignmentId(surveyId);
      };
      fetchData();
    }
  }, []);

  const fetchReportHtml = async () => {
    setLoading(true);
    try {
      const response: any = await axiosPost(getSurveyAssignmentReportHtml, {
        SurveyAssignmentId: surveyAssignmentId,
      });
      const data = response?.data?.ExtraData;
      setReportHtml(data);
    } catch (error) {
      setError("Report not Found");
    } finally {
      setLoading(false);
    }
  };

  const generatePDFBackend = async (surveyAssignmentId: number | undefined) => {
    setLoading(true);
    try {
      const response: any = await axiosPost(getSurveyAssignmentReportBytes, {
        SurveyAssignmentId: surveyAssignmentId,
      });
      const data = response?.data?.ExtraData;
      if (data) {
        downloadPdfFromBytes("SurveySummaryReport", data);
      } else {
        setError("No PDF data received");
      }
    } catch (error) {
      setError("Report not Found");
    } finally {
      setLoading(false);
    }
  };

  const generateWordBackend = async (
    surveyAssignmentId: number | undefined
  ) => {
    setLoading(true);
    try {
      const response: any = await axiosPost(
        getSurveyAssignmentReportWordBytes,
        {
          SurveyAssignmentId: surveyAssignmentId,
        }
      );
      const data = response?.data?.ExtraData;
      if (data) {
        downloadDocFromBytes("SurveySummaryReport", data);
      } else {
        setError("No Word data received");
      }
    } catch (error) {
      setError("Report not Found");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (surveyAssignmentId) {
      fetchReportHtml();
    }
  }, [surveyAssignmentId]);

  return reportHtml ? (
    <div>
      <div
        style={{
          margin: "2% 10% 0% 10%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <OrganizationLogo />
        <div>
          <Button
            onClick={() => generatePDFBackend(surveyAssignmentId)}
            style={{
              margin: "20px 10px 0px 0px",
              padding: "10px 20px",
              backgroundColor: "#2ca9b8",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Download PDF
          </Button>
          <Button
            onClick={() => generateWordBackend(surveyAssignmentId)}
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#2ca9b8",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Download Word
          </Button>
        </div>
      </div>
      <div id="report-content">
        <div
          style={{ margin: "0% 10%" }}
        >
          {parse(reportHtml)}
        </div>
      </div>
      {loading ? <Loader /> : null}
    </div>
  ) : null;
};

export default SurveySummaryReport;
